if (!customElements.get('floating-images')) {
  class FloatingImages extends HTMLElement {
    constructor() {
      super();
      this.tweens = [];
      this.mm = null;
    }

    connectedCallback() {
      this.ready();
    }

    disconnectedCallback() {
      this.stop();
    }

    ready(attempt = 0) {
      if (window.gsap && window.ScrollTrigger) {
        this.start();
        return;
      }
      if (attempt > 100) return;
      setTimeout(() => this.ready(attempt + 1), 100);
    }

    start() {
      if (this.tweens.length || this.mm) return;

      gsap.registerPlugin(ScrollTrigger);

      // Same drift distance across all 4 cards per breakpoint so they appear to move at the same speed.
      const layerConfigs = {
        mobile: [
          { selector: '.floating-image__top-left',     scrollY: -80 },
          { selector: '.floating-image__top-right',    scrollY: -80 },
          { selector: '.floating-image__bottom-left',  scrollY: -80 },
          { selector: '.floating-image__bottom-right', scrollY: -80 },
        ],
        tablet: [
          { selector: '.floating-image__top-left',     scrollY: -130 },
          { selector: '.floating-image__top-right',    scrollY: -130 },
          { selector: '.floating-image__bottom-left',  scrollY: -130 },
          { selector: '.floating-image__bottom-right', scrollY: -130 },
        ],
        desktop: [
          { selector: '.floating-image__top-left',     scrollY: -180 },
          { selector: '.floating-image__top-right',    scrollY: -180 },
          { selector: '.floating-image__bottom-left',  scrollY: -180 },
          { selector: '.floating-image__bottom-right', scrollY: -180 },
        ],
      };

      this.mm = gsap.matchMedia();

      const build = (layers) => {
        layers.forEach(({ selector, scrollY }) => {
          const el = this.querySelector(selector);
          if (!el) return;

          const parallax = gsap.to(el, {
            y: scrollY,
            ease: 'sine.out',
            scrollTrigger: {
              trigger: this,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1.2,
              invalidateOnRefresh: true,
              refreshPriority: -1,
            },
          });
          this.tweens.push(parallax);
        });
      };

      this.mm.add('(max-width: 766px)',  () => build(layerConfigs.mobile));
      this.mm.add('(min-width: 767px) and (max-width: 1023px)', () => build(layerConfigs.tablet));
      this.mm.add('(min-width: 1024px) and (max-width: 10000px)', () => build(layerConfigs.desktop));

      this.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
      });
    }

    stop() {
      this.tweens.forEach((tween) => {
        if (tween.scrollTrigger) tween.scrollTrigger.kill();
        tween.kill();
      });
      this.tweens = [];
      if (this.mm) {
        this.mm.revert();
        this.mm = null;
      }
    }
  }

  customElements.define('floating-images', FloatingImages);
}
